import { createIcon } from './svgIcon';

export const DropdownIcon = createIcon('DropdownIcon', <path d="M7 10l5 5 5-5H7z" />);
